import { render, staticRenderFns } from "./compKarpeg.vue?vue&type=template&id=b43f5a80&"
import script from "./compKarpeg.vue?vue&type=script&lang=js&"
export * from "./compKarpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QBtn,QList,QExpansionItem,QCard,QTooltip,QMarkupTable,QDialog,QFile,QIcon,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QBtn,QList,QExpansionItem,QCard,QTooltip,QMarkupTable,QDialog,QFile,QIcon,QInput,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
